import Immutable from 'immutable';

function hydrate(usePrevious = null) {
  if(!usePrevious){

    //activeLayer 如果style保存数据集的话，建筑所在的图层

    return {
      mapStyle: null,
      userInterface: Immutable.fromJS({
        activeButton: 'age',
        activeLayer: 'data_from_rui-extrusion',
        popup: null
      })
    };
  }
}

const InitialState = hydrate();
export default InitialState;
